var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:_vm.classNames,attrs:{"dateItem":"item"},on:{"click":function($event){return _vm.$emit('selected', _vm.item)}}},[_c('a',[_vm._v(_vm._s(_vm.item.day))]),_c('div',{staticClass:"plan-wrap"},_vm._l((_vm.colors),function(color,index){return _c('CalendarDayColor',{key:index,attrs:{"item":color}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }